import declarationCreate from './view/declarationCreate.html'

export default {
  base: {
    state: 'declaration.addValTaxSmallScale.declarationCreate',
    config: {
      url: '/declarationCreate',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.addValTaxSmallScale.declarationCreate.list',
      title: '申报表生成',
    },
  },
  list: {
    state: 'declaration.addValTaxSmallScale.declarationCreate.list',
    config: {
      url: '/list',
      template: declarationCreate,
      controller: 'declarationCreateCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/declarationCreate/routers.js